
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3176',
  depVersions: {
  "customer-portal-app": "static-1.3176",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.501",
  "data-fetching-client": "static-1.9997",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26262",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5934",
  "hs-test-utils": "static-1.8381",
  "hub-http": "static-1.6556",
  "hub-http-shared-msw-handlers": "static-1.10686",
  "hubspot-dlb": "static-2.1905",
  "hubspot-prosemirror": "static-1.19053",
  "hubspot-url-utils": "static-1.4366",
  "HubStyleTokens": "static-2.11836",
  "I18n": "static-7.1680",
  "immutable": "static-2.87",
  "jasmine-runner": "static-1.6794",
  "payment-link-components": "static-1.24222",
  "portals-platform-bend-plugin": "static-1.23",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7512",
  "quartz-core": "static-1.6731",
  "quartz-i18n": "static-1.1187",
  "react": "static-7.196",
  "react-colorpicker": "static-2.10557",
  "react-dlb": "static-1.89",
  "react-utils": "static-2.5585",
  "reselect": "static-3.12",
  "rich-text-lib": "static-1.20361",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18434",
  "ui-components-test-utils": "static-1.5973",
  "UIComponents": "static-3.8782",
  "foundations-assets": "static-1.5231",
  "foundations-components": "static-1.8553",
  "foundations-theming": "static-1.4820",
  "foundations-theming-specialty": "static-1.2536",
  "framer-motion": "static-1.79",
  "metrics-js": "static-1.9963",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1503",
  "quartz-config": "static-1.1290",
  "quartz-routing": "static-1.942",
  "quick-fetch": "static-1.4157",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17068",
  "rpc-client-utils": "static-1.5010",
  "sanitize-text": "static-1.8501",
  "styled-components": "static-2.99",
  "tanstack-table": "static-1.61",
  "ui-addon-draggable": "static-3.5101",
  "ui-addon-react-router-dom": "static-1.9876",
  "usage-tracker": "static-1.7657",
  "usage-tracker-anonymous": "static-1.6074",
  "usage-tracker-core": "static-1.7507",
  "video-components-external": "static-1.12218",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.79",
  "redux": "static-4.80",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3789",
  "quartz-webpack": "static-1.3736",
  "bend-plugin-quartz-routing": "static-1.590",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.89",
  "customer-data-objects": "static-1.8042",
  "frontend-preferences-client": "static-1.8263",
  "laboratory-lib": "static-3.7497",
  "onboarding-scopes": "static-1.6797",
  "seat-types-lib": "static-1.799",
  "ui-addon-opt": "static-4.8710",
  "HeadJS": "static-2.804",
  "hs-test-utils-bend-plugin": "static-1.3492",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "hs-locale-management": "static-1.324",
  "ts-schema": "static-1.4323",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8252",
  "content-media-capture": "static-1.5525",
  "cssUtils": "static-1.966",
  "customer-data-ui-utilities": "static-1.10175",
  "file-manager-components": "static-1.24592",
  "HubStyle": "static-2.12143",
  "knowledge-content-types": "static-1.8689",
  "PatternValidationJS": "static-1.3235",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.508",
  "ui-addon-emoji-picker": "static-1.10228",
  "ui-addon-i18n": "static-1.11490",
  "ui-business-units-lib": "static-1.9435",
  "ui-shepherd-react": "static-3.10614",
  "video-data-lib": "static-1.35876",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4656",
  "commerce-tours-lib": "static-1.6678",
  "customer-data-properties": "static-1.52702",
  "getting-started-shared-tasks": "static-1.19322",
  "growth-onboarding-reliability": "static-1.5424",
  "onboarding-tours": "static-1.17192",
  "reference-resolvers-lite": "static-1.8448",
  "sales-checkout-service-client": "static-1.3872",
  "ui-addon-iframeable": "static-1.9421",
  "user-context": "static-1.5465",
  "bender-build-tools": "static-1.3452",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.888",
  "hubspotter-http": "static-1.4893",
  "icons": "static-2.694",
  "mobile-manifest-mixins": "static-1.584",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.497",
  "quartz-auth": "static-1.1187",
  "quartz-head": "static-1.1177",
  "quartz-test": "static-1.1187",
  "quartz-tracking": "static-1.891",
  "trellis-components": "static-1.2765",
  "ui-fonts": "static-1.1098",
  "usage-tracker-container": "static-1.7647",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9769",
  "data-token-picker": "static-1.16941",
  "FileManagerLib": "static-1.40232",
  "property-translator": "static-1.5737",
  "merchandise-lib": "static-1.279",
  "purchase-motions-components": "static-1.6435",
  "SharedI18nStrings": "static-1.183",
  "foundations-components-test-utils": "static-1.6036",
  "react-create-root-preference": "static-1.79",
  "react-select-plus": "static-1.113",
  "react-virtualized": "static-2.107",
  "ui-images": "static-2.1264",
  "bend-plugin-foundations-components": "static-1.4822",
  "floating-ui": "static-1.63",
  "react-aria": "static-1.72",
  "trellis-assets": "static-1.2746",
  "bend-plugin-foundations-theming": "static-1.3303",
  "foundations-theming-base": "static-1.3805",
  "stylex": "static-1.41",
  "interframe": "static-3.5099",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6071",
  "opentelemetry-fe-types": "static-1.122",
  "web-vitals": "static-1.15",
  "bend-plugin-chirp-manifest": "static-1.420",
  "chirp-fetch": "static-1.2240",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4816",
  "react-flip-move": "static-1.78",
  "apollo-link-hub-http": "static-2.5001",
  "content-media-composition-data-lib": "static-1.13329",
  "content-media-compositions": "static-2.17336",
  "idb-keyval": "static-1.51",
  "immer": "static-1.101",
  "immerable": "static-1.4490",
  "magpie-lib": "static-1.5787",
  "magpie-types": "static-1.5247",
  "media-bridge-lib": "static-1.19459",
  "inbound-db-properties-service-client": "static-1.4077",
  "superstore": "static-1.5103",
  "feedback-loader": "static-1.29865",
  "ai-components-ui-library": "static-1.9799",
  "ui-addon-video-player": "static-1.9046",
  "ui-coaching-tips": "static-1.29381",
  "ContentUtils": "static-1.69205",
  "fix-webm-duration": "static-1.30",
  "notification-sounds": "static-1.4769",
  "sassPrefix": "static-1.233",
  "react-dnd-compat": "static-1.4960",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1840",
  "copilot-toolkit": "static-1.11916",
  "atom": "static-1.5426",
  "avatar-components": "static-1.2826",
  "navigation-messaging": "static-1.8235",
  "redux-thunk": "static-2.80",
  "reference-resolvers": "static-1.8525",
  "commerce-products-lib": "static-1.10622",
  "crm-message-bus": "static-1.43848",
  "growth-data-modal": "static-1.5949",
  "hubspot-apollo-client": "static-1.5221",
  "onboarding-tours-client": "static-1.5407",
  "batch-promise": "static-1.1889",
  "calling-global-api": "static-1.65750",
  "calling-internal-common": "static-1.31666",
  "calling-lifecycle-internal": "static-1.67132",
  "calling-lifecycle-messages": "static-1.59426",
  "conditional-properties-service-client": "static-1.4046",
  "crm-index-visualization-core": "static-1.4592",
  "crm-links": "static-1.6658",
  "crm-pipelines-api-client-types": "static-1.4377",
  "customer-data-objects-ui-components": "static-1.13375",
  "customer-data-properties-shared-msw-handlers": "static-1.10013",
  "customer-data-property-utils": "static-1.8442",
  "external-options-client-types": "static-1.4370",
  "formula-editor": "static-1.14825",
  "framework-data-schema-resolvers": "static-1.7237",
  "google-libphonenumber": "static-1.45",
  "hs-resources": "static-1.537",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4457",
  "meetings-icalendar-utils-lib": "static-1.979",
  "multi-currency-client-types": "static-1.3937",
  "object-builder-ui-client": "static-1.49769",
  "pipeline-validation-client-types": "static-1.4212",
  "property-value-citations": "static-1.3316",
  "pulse": "static-1.974",
  "smart-data-capture-core": "static-1.209",
  "smart-property-lib": "static-1.8379",
  "tiered-pricing": "static-1.2022",
  "topics-actions-lib": "static-1.514",
  "trial-components-library": "static-1.14174",
  "ui-addon-form-validation": "static-1.11328",
  "zustand": "static-1.85",
  "growth-onboarding-confetti": "static-1.3409",
  "growth-onboarding-next-action-utils": "static-1.2762",
  "navigation-components": "static-1.18908",
  "onboarding-tours-utils": "static-1.1259",
  "ui-shepherd-tracker": "static-1.7995",
  "ui-universal-auth": "static-1.9476",
  "getting-started-shared-tasks-store": "static-1.18440",
  "beacon-keepalive-queue": "static-1.48",
  "opentelemetry-web": "static-1.15",
  "hubspotter-http-shared-msw-handlers": "static-1.10684",
  "usage-tracker-session-replay": "static-1.5343",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "trellis-theming": "static-1.1318",
  "tanstack-virtual": "static-1.38",
  "audio-components": "static-1.6399",
  "FileManagerCore": "static-1.40091",
  "FileManagerImages": "static-1.37743",
  "video-components": "static-1.14220",
  "foundations-components-legacy": "static-1.1578",
  "purchase-motions-api": "static-1.6438",
  "signup-constants": "static-1.19693",
  "signup-ui-url-generator": "static-2.8404",
  "stylex-utils": "static-1.148",
  "usage-tracker-public": "static-1.7468",
  "reactive-lib": "static-1.1063",
  "simple-logging-lib": "static-1.3395",
  "chatspot-core": "static-1.23202",
  "growth-onboarding-feedback-components": "static-1.6929",
  "cms-field-types": "static-1.5156",
  "content-icons-ui": "static-1.2407",
  "integrations-lib": "static-1.17148",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.818",
  "breeze-engine-core": "static-1.1118",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.1121",
  "customer-data-tracking": "static-1.7226",
  "products-iframe-lib": "static-1.8658",
  "products-ui-components-shared-msw-handlers": "static-1.11068",
  "restore-request-side-panel-lib": "static-1.1750",
  "onboarding-data-sync-lib": "static-1.2576",
  "hubspot-apollo-cache": "static-1.680",
  "calling-error-reporting": "static-1.31673",
  "shared-worker-versioning": "static-1.11385",
  "calling-usage-tracker": "static-1.6880",
  "voice-sms-access-library": "static-1.2143",
  "conversations-skeleton-state": "static-1.7591",
  "crm-index-associations-lib": "static-1.6788",
  "framework-data-schema-quick-fetch": "static-1.7142",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10769",
  "redux-toolkit": "static-1.78",
  "sales-views-client-types": "static-1.4600",
  "location-customization-utils-lib": "static-1.10178",
  "bark-lib": "static-1.16859",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.102",
  "crm-properties-common-lib": "static-1.6234",
  "react-codemirror": "static-1.10987",
  "fdsr-migration-layer": "static-1.356",
  "framework-builder-read-service-client": "static-1.4251",
  "persist-promise": "static-1.4046",
  "event-emitter": "static-1.1300",
  "bend-plugin-pulse": "static-1.477",
  "fast-json-patch": "static-1.70",
  "data-agent-kit": "static-1.707",
  "fsm": "static-1.4097",
  "policy-lib": "static-1.7149",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10832",
  "embedded-academy-lib": "static-1.15646",
  "hubs-service-types": "static-1.1604",
  "salesImages": "static-1.604",
  "growth-onboarding-next-action-components": "static-1.2790",
  "user-context-client": "static-1.4852",
  "nest": "static-1.581",
  "unified-auth-core-lib": "static-1.1272",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.472",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4874",
  "video-embed": "static-1.36710",
  "social-insights-client-types": "static-1.22711",
  "flux-actions": "static-1.374",
  "integrations-error-boundary-lib": "static-1.14563",
  "integrations-tracking-lib": "static-1.5952",
  "native-integrations-shared-strings": "static-1.8121",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10714",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.990",
  "InboxConnectUtils": "static-4.15628",
  "meetings-connect-utils-lib": "static-1.7955",
  "calling-orchestration-schema": "static-1.36920",
  "crm-record-cards-service-types": "static-1.3796",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16436",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.111",
  "trellis-story-utils": "static-1.4851",
  "storybook-react": "static-1.40",
  "academy-common-lib": "static-1.15106",
  "outpost": "static-1.4496",
  "universal-page-editor-lib": "static-1.3352",
  "adobe-sign-auth-lib": "static-1.540",
  "ads-unified-auth-lib": "static-1.1508",
  "custom-vendor-connection-lib": "static-1.40",
  "google-sheets-integration-lib": "static-1.1103",
  "microsoft-drive-auth-lib": "static-1.223",
  "surveymonkey-integration-lib": "static-1.563",
  "slack-ui-library": "static-1.10743",
  "hub-http-contrib": "static-1.3384",
  "ui-addon-sales-email": "static-1.5558",
  "academy-service-client": "static-1.4036",
  "croppie": "static-2.10",
  "final-form": "static-1.78",
  "SafeStorage": "static-1.4750",
  "trellis-ecosystem": "static-1.7680",
  "wootric-nps": "static-1.7230",
  "marketplace-ui-apps-core": "static-1.19343",
  "marketplace-ui-common": "static-1.20811",
  "developer-experience-shared-components": "static-1.10882",
  "immutable-less": "static-1.4995",
  "marketplace-ui-client-types": "static-1.18218",
  "ui-addon-integrations-directory-panel": "static-2.8371",
  "ui-extensibility-client-types": "static-1.4261",
  "ai-settings-ui-library": "static-1.8397",
  "nav-meta": "static-1.30545",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1188",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4577",
  "settings-ui-lib": "static-1.12868",
  "simple-data-table": "static-1.3587"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3176",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.501",
  "data-fetching-client": "/data-fetching-client/static-1.9997",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26262",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5934",
  "hs-test-utils": "/hs-test-utils/static-1.8381",
  "hub-http": "/hub-http/static-1.6556",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10686",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19053",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "HubStyleTokens": "/HubStyleTokens/static-2.11836",
  "I18n": "/I18n/static-7.1680",
  "immutable": "/immutable/static-2.87",
  "jasmine-runner": "/jasmine-runner/static-1.6794",
  "payment-link-components": "/payment-link-components/static-1.24222",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.23",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7512",
  "quartz-core": "/quartz-core/static-1.6731",
  "quartz-i18n": "/quartz-i18n/static-1.1187",
  "react": "/react/static-7.196",
  "react-colorpicker": "/react-colorpicker/static-2.10557",
  "react-dlb": "/react-dlb/static-1.89",
  "react-utils": "/react-utils/static-2.5585",
  "reselect": "/reselect/static-3.12",
  "rich-text-lib": "/rich-text-lib/static-1.20361",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18434",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5973",
  "UIComponents": "/UIComponents/static-3.8782",
  "foundations-assets": "/foundations-assets/static-1.5231",
  "foundations-components": "/foundations-components/static-1.8553",
  "foundations-theming": "/foundations-theming/static-1.4820",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2536",
  "framer-motion": "/framer-motion/static-1.79",
  "metrics-js": "/metrics-js/static-1.9963",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1503",
  "quartz-config": "/quartz-config/static-1.1290",
  "quartz-routing": "/quartz-routing/static-1.942",
  "quick-fetch": "/quick-fetch/static-1.4157",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17068",
  "rpc-client-utils": "/rpc-client-utils/static-1.5010",
  "sanitize-text": "/sanitize-text/static-1.8501",
  "styled-components": "/styled-components/static-2.99",
  "tanstack-table": "/tanstack-table/static-1.61",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5101",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9876",
  "usage-tracker": "/usage-tracker/static-1.7657",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6074",
  "usage-tracker-core": "/usage-tracker-core/static-1.7507",
  "video-components-external": "/video-components-external/static-1.12218",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.79",
  "redux": "/redux/static-4.80",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3789",
  "quartz-webpack": "/quartz-webpack/static-1.3736",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.590",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.89",
  "customer-data-objects": "/customer-data-objects/static-1.8042",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8263",
  "laboratory-lib": "/laboratory-lib/static-3.7497",
  "onboarding-scopes": "/onboarding-scopes/static-1.6797",
  "seat-types-lib": "/seat-types-lib/static-1.799",
  "ui-addon-opt": "/ui-addon-opt/static-4.8710",
  "HeadJS": "/HeadJS/static-2.804",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3492",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "hs-locale-management": "/hs-locale-management/static-1.324",
  "ts-schema": "/ts-schema/static-1.4323",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8252",
  "content-media-capture": "/content-media-capture/static-1.5525",
  "cssUtils": "/cssUtils/static-1.966",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10175",
  "file-manager-components": "/file-manager-components/static-1.24592",
  "HubStyle": "/HubStyle/static-2.12143",
  "knowledge-content-types": "/knowledge-content-types/static-1.8689",
  "PatternValidationJS": "/PatternValidationJS/static-1.3235",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.508",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10228",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11490",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9435",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10614",
  "video-data-lib": "/video-data-lib/static-1.35876",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4656",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6678",
  "customer-data-properties": "/customer-data-properties/static-1.52702",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19322",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5424",
  "onboarding-tours": "/onboarding-tours/static-1.17192",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8448",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3872",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9421",
  "user-context": "/user-context/static-1.5465",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.888",
  "hubspotter-http": "/hubspotter-http/static-1.4893",
  "icons": "/icons/static-2.694",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.584",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.497",
  "quartz-auth": "/quartz-auth/static-1.1187",
  "quartz-head": "/quartz-head/static-1.1177",
  "quartz-test": "/quartz-test/static-1.1187",
  "quartz-tracking": "/quartz-tracking/static-1.891",
  "trellis-components": "/trellis-components/static-1.2765",
  "ui-fonts": "/ui-fonts/static-1.1098",
  "usage-tracker-container": "/usage-tracker-container/static-1.7647",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9769",
  "data-token-picker": "/data-token-picker/static-1.16941",
  "FileManagerLib": "/FileManagerLib/static-1.40232",
  "property-translator": "/property-translator/static-1.5737",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "purchase-motions-components": "/purchase-motions-components/static-1.6435",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6036",
  "react-create-root-preference": "/react-create-root-preference/static-1.79",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-virtualized": "/react-virtualized/static-2.107",
  "ui-images": "/ui-images/static-2.1264",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4822",
  "floating-ui": "/floating-ui/static-1.63",
  "react-aria": "/react-aria/static-1.72",
  "trellis-assets": "/trellis-assets/static-1.2746",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3303",
  "foundations-theming-base": "/foundations-theming-base/static-1.3805",
  "stylex": "/stylex/static-1.41",
  "interframe": "/interframe/static-3.5099",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6071",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.122",
  "web-vitals": "/web-vitals/static-1.15",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.420",
  "chirp-fetch": "/chirp-fetch/static-1.2240",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4816",
  "react-flip-move": "/react-flip-move/static-1.78",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5001",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13329",
  "content-media-compositions": "/content-media-compositions/static-2.17336",
  "idb-keyval": "/idb-keyval/static-1.51",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4490",
  "magpie-lib": "/magpie-lib/static-1.5787",
  "magpie-types": "/magpie-types/static-1.5247",
  "media-bridge-lib": "/media-bridge-lib/static-1.19459",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4077",
  "superstore": "/superstore/static-1.5103",
  "feedback-loader": "/feedback-loader/static-1.29865",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9799",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9046",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29381",
  "ContentUtils": "/ContentUtils/static-1.69205",
  "fix-webm-duration": "/fix-webm-duration/static-1.30",
  "notification-sounds": "/notification-sounds/static-1.4769",
  "sassPrefix": "/sassPrefix/static-1.233",
  "react-dnd-compat": "/react-dnd-compat/static-1.4960",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1840",
  "copilot-toolkit": "/copilot-toolkit/static-1.11916",
  "atom": "/atom/static-1.5426",
  "avatar-components": "/avatar-components/static-1.2826",
  "navigation-messaging": "/navigation-messaging/static-1.8235",
  "redux-thunk": "/redux-thunk/static-2.80",
  "reference-resolvers": "/reference-resolvers/static-1.8525",
  "commerce-products-lib": "/commerce-products-lib/static-1.10622",
  "crm-message-bus": "/crm-message-bus/static-1.43848",
  "growth-data-modal": "/growth-data-modal/static-1.5949",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5221",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5407",
  "batch-promise": "/batch-promise/static-1.1889",
  "calling-global-api": "/calling-global-api/static-1.65750",
  "calling-internal-common": "/calling-internal-common/static-1.31666",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67132",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59426",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4046",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4592",
  "crm-links": "/crm-links/static-1.6658",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4377",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13375",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10013",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8442",
  "external-options-client-types": "/external-options-client-types/static-1.4370",
  "formula-editor": "/formula-editor/static-1.14825",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7237",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "hs-resources": "/hs-resources/static-1.537",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4457",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.979",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3937",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49769",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4212",
  "property-value-citations": "/property-value-citations/static-1.3316",
  "pulse": "/pulse/static-1.974",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.209",
  "smart-property-lib": "/smart-property-lib/static-1.8379",
  "tiered-pricing": "/tiered-pricing/static-1.2022",
  "topics-actions-lib": "/topics-actions-lib/static-1.514",
  "trial-components-library": "/trial-components-library/static-1.14174",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11328",
  "zustand": "/zustand/static-1.85",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3409",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2762",
  "navigation-components": "/navigation-components/static-1.18908",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1259",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7995",
  "ui-universal-auth": "/ui-universal-auth/static-1.9476",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18440",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.48",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10684",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5343",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "trellis-theming": "/trellis-theming/static-1.1318",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "audio-components": "/audio-components/static-1.6399",
  "FileManagerCore": "/FileManagerCore/static-1.40091",
  "FileManagerImages": "/FileManagerImages/static-1.37743",
  "video-components": "/video-components/static-1.14220",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1578",
  "purchase-motions-api": "/purchase-motions-api/static-1.6438",
  "signup-constants": "/signup-constants/static-1.19693",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8404",
  "stylex-utils": "/stylex-utils/static-1.148",
  "usage-tracker-public": "/usage-tracker-public/static-1.7468",
  "reactive-lib": "/reactive-lib/static-1.1063",
  "simple-logging-lib": "/simple-logging-lib/static-1.3395",
  "chatspot-core": "/chatspot-core/static-1.23202",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6929",
  "cms-field-types": "/cms-field-types/static-1.5156",
  "content-icons-ui": "/content-icons-ui/static-1.2407",
  "integrations-lib": "/integrations-lib/static-1.17148",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.818",
  "breeze-engine-core": "/breeze-engine-core/static-1.1118",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.1121",
  "customer-data-tracking": "/customer-data-tracking/static-1.7226",
  "products-iframe-lib": "/products-iframe-lib/static-1.8658",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11068",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1750",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2576",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.680",
  "calling-error-reporting": "/calling-error-reporting/static-1.31673",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11385",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6880",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2143",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7591",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6788",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7142",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10769",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "sales-views-client-types": "/sales-views-client-types/static-1.4600",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10178",
  "bark-lib": "/bark-lib/static-1.16859",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6234",
  "react-codemirror": "/react-codemirror/static-1.10987",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.356",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4251",
  "persist-promise": "/persist-promise/static-1.4046",
  "event-emitter": "/event-emitter/static-1.1300",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.477",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "data-agent-kit": "/data-agent-kit/static-1.707",
  "fsm": "/fsm/static-1.4097",
  "policy-lib": "/policy-lib/static-1.7149",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10832",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15646",
  "hubs-service-types": "/hubs-service-types/static-1.1604",
  "salesImages": "/salesImages/static-1.604",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2790",
  "user-context-client": "/user-context-client/static-1.4852",
  "nest": "/nest/static-1.581",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1272",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.472",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4874",
  "video-embed": "/video-embed/static-1.36710",
  "social-insights-client-types": "/social-insights-client-types/static-1.22711",
  "flux-actions": "/flux-actions/static-1.374",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14563",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5952",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8121",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10714",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.990",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15628",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7955",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36920",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16436",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.111",
  "trellis-story-utils": "/trellis-story-utils/static-1.4851",
  "storybook-react": "/storybook-react/static-1.40",
  "academy-common-lib": "/academy-common-lib/static-1.15106",
  "outpost": "/outpost/static-1.4496",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3352",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.540",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1508",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.40",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1103",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.223",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.563",
  "slack-ui-library": "/slack-ui-library/static-1.10743",
  "hub-http-contrib": "/hub-http-contrib/static-1.3384",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5558",
  "academy-service-client": "/academy-service-client/static-1.4036",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.78",
  "SafeStorage": "/SafeStorage/static-1.4750",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7680",
  "wootric-nps": "/wootric-nps/static-1.7230",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19343",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20811",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10882",
  "immutable-less": "/immutable-less/static-1.4995",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18218",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8371",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4261",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8397",
  "nav-meta": "/nav-meta/static-1.30545",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1188",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4577",
  "settings-ui-lib": "/settings-ui-lib/static-1.12868",
  "simple-data-table": "/simple-data-table/static-1.3587"
}
};
